<template>
  <v-card>
    <v-card-title>
      {{section ? 'Edit' : 'Add'}} Section
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Name"
          v-model="name"
          :rules="nameRules"
          :counter="35"
          @blur="checkName"
          required></v-text-field>
      </v-form>
    </v-card-text>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-layout column align-end class="px-2">
      <a
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Submit
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
  </v-card>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    props: ['section'],
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 35) || 'Name must be less than 35 characters',
      ],
      err: '',
    }),
    methods: {
      async checkName() {
        this.err = '';
        const where = {};
        where.name = this.name;
        const res = await webHelper.post(this, 'section/name', where);
        if (res.failed || !res.isNameAvailable) {
          this.err = 'Name You chose is already taken.';
        }
      },
      async submit() {
        const section = {
          name: this.name,
        };
        if (this.section) {
          Object.assign(section, { id: this.section._id });
        }
        const method = this.section ? 'put' : 'post';
        const res = await webHelper[method](this, 'section', section);
        if (res.failed) {
          this.err = 'Failed to submit data';
          return;
        }
        this.$emit('submit', section);
      },
    },
    created() {
      if (this.section) {
        this.name = this.section.name;
      }
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/Section.vue